import i18n from "i18next";
import { initReactI18next } from "react-i18next";



// Importing translation files

import translationEN from "./locales/en/translation.json";
import translationHE from "./locales/zh/translation.json";


//Creating object with the variables of imported translation files
const resources = {
  en: {
    translation: translationEN,
  },  
  zh: {
    translation: translationHE,
  },
};

var select_lang = localStorage.getItem("selectLang") == null ? false : localStorage.getItem("selectLang")

if(!select_lang){
  select_lang = 'en';
  localStorage.setItem("selectLang", select_lang);  
}
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng:select_lang, //"en", //default language
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;